export enum SightWordsSteps {
	Students = 1,
	TestSelector,
	PrintSettings,
	Preview,
	Final,
}